import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { NextPageService, NextPageRoute } from '@cvx/nextpage';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CalAngularModule } from '@cvx/cal-angular';
import { AuthGuardService } from './auth-guard.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authInterceptor } from './auth.interceptor';
import { RoleGuard } from '../app/role-guard';

function getVisibleRoutes(routes: NextPageRoute[]): NextPageRoute[] {
  return routes.map((route: NextPageRoute) => {
    if (route.children) {
      return {
        ...route,
        children: route.children.filter(
          (child: NextPageRoute) => child.path !== 'PreviewReport'
        ),
      };
    }
    return route;
  });
}

const nextPageService = new NextPageService();
nextPageService.options.navigationRoutes = getVisibleRoutes(routes);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: NextPageService, useValue: nextPageService },
    ...(CalAngularModule.forRoot('assets/config.json').providers || []),
    AuthGuardService,
    RoleGuard, 
    provideAnimationsAsync(),
  ],
};
